/* eslint-disable no-magic-numbers */
import React from 'react';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';
import { Accordion } from 'carbon-react/lib/components/accordion';
import Icon from 'carbon-react/lib/components/icon';
import Typography from 'carbon-react/lib/components/typography';
import Divider from 'carbon-react/lib/components/divider';

import { UILoaderSpinner } from '@futrli/ui-components';
import { ExcelEntityConfig } from '@futrli/views/ExcelFilesView';
import { useExcelFilesView } from '@futrli/views/hooks/useExcelFilesView';

import { downloadExcelFile } from '../hooks/utils';
import styles from './excel-modal-content.scss';

interface Props {
  workspaceId: string;
  organisationId: string;
  config: ExcelEntityConfig;
}

export const UpdateHistory = ({ workspaceId, organisationId, config }: Props) => {
  const { files, isFetchingFiles } = useExcelFilesView(workspaceId, organisationId, config);

  if (isFetchingFiles) {
    return (
      <>
        <Divider type="horizontal" />
        <div className={styles.updateHistoryLoading}>
          <UILoaderSpinner size="small" />
        </div>
      </>
    );
  }

  return (
    <>
      <Divider type="horizontal" />
      <div className={styles.updateHistoryAccordion}>
        <Accordion
          title={
            <Typography fontSize="16px" fontWeight="500" color="var(--colors-action-major-500, #007E45)" mb={0}>
              <FormattedMessage id="predict.update_history" defaultMessage="Update history" />
            </Typography>
          }
          defaultExpanded
        >
          {files.map((file, i) => (
            <div key={i} className={styles.updateHistoryRow}>
              <div className={styles.updateHistoryFile}>
                <Icon type="file_excel" color="#99ADB7" />
                <Typography fontSize="14px" mb={0} fontWeight="500">
                  {format(new Date(file.created_at), 'dd/MM/yyyy')}
                </Typography>
              </div>
              <button
                className={styles.updateHistoryDownload}
                onClick={e => {
                  e.preventDefault();
                  downloadExcelFile(file.file_url, file.file_name);
                }}
              >
                <FormattedMessage id="common.download" defaultMessage="Download" />
                <Icon type="download" color="#007e45" />
              </button>
            </div>
          ))}
        </Accordion>
      </div>
    </>
  );
};
